import { useMemo, useState } from "react";
import { ProductGroup } from "../../../api/product/productTypes"
import useGetSkus from "../../../hooks/useGetSkus";
import { Flex, Spin, Tooltip, Transfer } from "antd";
import { TransferDirection, TransferItem } from "antd/es/transfer";
// import { useGetProductsByIdQuery } from "../../../api/product/productsApi";
// import { skipToken } from "@reduxjs/toolkit/query";
// import { DataMapping } from "../../../api/dataMappingApi";

export default function SkuManagementTab(props: {
  p: ProductGroup;
  setP: (p: ProductGroup) => void;
}) {
  // const [searchQuery, setSearchQuery] = useState("");
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  // const { data: existSelData } = useGetProductsByIdQuery(
    // props.p.ProductIds ?? skipToken);
  const { data, isFetching } = useGetSkus(/* searchQuery */);
  const allData = useMemo(() =>
    ([...data /*, ...existSelData ?? [] */])
  , [data /* , existSelData */]);
  const allTrfItems: TransferItem[] = useMemo(() => {
    const d = allData.map(x => ({
      key: x.Id,
      title: (x.ItemDetails?.Title ?? "") + " (" + x.InternalSku + ")",
    }));

    // distinct
    const o: any = {};
    for (const row of d) {
      if (o[row.key] === undefined) {
        o[row.key] = row.title;
      }
    }
    const ks = Object.keys(o);
    const ret = [];
    for (const k of ks) {
      ret.push({ key: k, title: o[k] });
    }
    return ret;
  }, [allData]);

  /**
   * Performance improvement
   */
  // useEffect(() => {
  //   setSelectedKeys([]);
  // }, []);

  function handleTransfer(targetKeys: string[],
                          direction: TransferDirection,
                          moveKeys: string[]) {
    console.log("transferring", targetKeys, direction, moveKeys);
    if (direction === "right") {
      const origIds = props.p.ProductIds ?? [];
      // dedupe
      const items = [...new Set([...origIds, ...targetKeys])];
      props.setP({ ...props.p, ProductIds: items})
    } else {
      const newIds = props.p.ProductIds?.filter(x => !moveKeys.includes(x));
      props.setP({ ...props.p, ProductIds: newIds });
    }
  }

  function handleSelectedChange(source: string[], target: string[]) {
    console.log("handling selected change", source, target);
    setSelectedKeys([...source, ...target]);
  }

  function handleFilter(search: string, option: TransferItem) {
    return option.title!.toLowerCase().includes(search.toLowerCase());
  }

  return <>
    <Flex gap={8} vertical>
      {/* <Input
        addonBefore="Search by title or SKU"
        placeholder="Enter at least 3 characters"
        value={searchQuery}
        onChange={e => setSearchQuery(e.target.value)}
      /> */}
      { isFetching && <Spin /> }
      <Transfer
        dataSource={allTrfItems}
        titles={["SIMPLY SKUs", "Selected SKUs"]}
        targetKeys={props.p.ProductIds ?? []}
        selectedKeys={selectedKeys}
        onChange={handleTransfer}
        onSelectChange={handleSelectedChange}
        // render={x => (x.ItemDetails?.Title ?? "") + " (" + x.InternalSku + ")"}
        render={x =>
          <Tooltip title={x.title} placement="topLeft">
            {x.title}
          </Tooltip>
        }
        listStyle={{ flex: 1, minHeight: 400 }}
        showSearch
        filterOption={handleFilter}
        pagination
      />
    </Flex>
  </>
}